import { Color } from 'projects/consts';
import React from 'react';

const ColorComponent: React.SFC<{ color: Color }> = ({ color, children }) => (
    <div style={{ color }}>{children}</div>
);

export default ColorComponent;
